import axios from "axios";
import { checkTokenExpiry } from "./checkTokenExpiry";
import { Notyf } from "notyf";
import { sessionDataDec } from "./sessionServiceEndDec";

const LOGIN_BASE_URL = import.meta.env.VITE_LOGIN_BASE_URL;
const AUTH_BASE_URL = import.meta.env.VITE_AUTH_BASE_URL;
const MW_BASE_URL = import.meta.env.VITE_MW_BASE_URL;
const ZENDESK_BASE_URL = import.meta.env.VITE_ZENDESK_BASE_URL;
const PINCODE_BASE_URL = import.meta.env.VITE_PINCODE_BASE_URL;
const HEADER_CHABI = import.meta.env.VITE_HEADER_CHABI;


export const LoginApi = (url, data) => {
  const client = axios.create({
    baseURL: LOGIN_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: HEADER_CHABI, // include if needed
    },
  });

  return client
    .post(url, data)
    .then((res) => res.data)
    .catch((err) => {
      console.error("LoginApi error:", err);
      return Promise.reject(err); // rethrow for caller
    });
};

export const RefreshApi = (url, data) => {
  const client = axios.create({
    baseURL: LOGIN_BASE_URL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: HEADER_CHABI, // include if needed
    },
  });

  return client
    .post(url, data)
    .then((res) => res.data)
    .catch((err) => {
      console.error("LoginApi error:", err);
      return Promise.reject(err); // rethrow for caller
    });
};

export const DashboardApi = async (url) => {
  const valid = await checkTokenExpiry();
  if (!valid) return;
  let token = sessionDataDec('token')
  const client = axios.create({
    baseURL: AUTH_BASE_URL,
    headers: {
      "Content-Type": "application/json",
      Authorization: token, // include if needed
    },
  });

  return client
    .get(url)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response?.data?.error?.message?.valid === false) {
        const notyf = new Notyf();
        notyf.dismissAll();
        window.dispatchEvent(new Event("session-expired"));
        return; // stop promise chain (like Angular's EMPTY)
      }
      console.error("LoginApi error:", err);
      return Promise.reject(err); // rethrow for caller
    });
};

export const MiddleWarePostApi = async (url, data) => {

  const valid = await checkTokenExpiry();
  if (!valid) return;
  let token = sessionDataDec('token')

  const client = axios.create({
    baseURL: MW_BASE_URL,
    headers: {
      "Content-Type": "application/json",
      Authorization: token, // include if needed
    },
  });

  return client
    .post(url, data)
    .then((res) => res.data)
    .catch((err) => {
      // API error handling
      if (err.response?.data?.error?.message?.valid === false) {
        const notyf = new Notyf();
        notyf.dismissAll();
        window.dispatchEvent(new Event("session-expired"));
        return; // stop promise chain (like Angular's EMPTY)
      }
      console.error("DashboardApi error:", err);
      return Promise.reject(err);
    });
};

export const MiddleWareGetApi = async (url) => {
  const valid = await checkTokenExpiry();
  if (!valid) return;
  let token = sessionDataDec('token')

  const client = axios.create({
    baseURL: MW_BASE_URL,
    headers: {
      "Content-Type": "application/json",
      Authorization: token, // include if needed
    },
  });

  return client
    .get(url)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response?.data?.error?.message?.valid === false) {
        const notyf = new Notyf();
        notyf.dismissAll();
        window.dispatchEvent(new Event("session-expired"));
        return; // stop promise chain (like Angular's EMPTY)
      }
      console.error("LoginApi error:", err);
      return Promise.reject(err); // rethrow for caller
    });
};

export const MiddleWarePostApiForExcel = async (url, data) => {

  const valid = await checkTokenExpiry();
  if (!valid) return;
  let token = sessionDataDec('token')

  const client = axios.create({
    baseURL: MW_BASE_URL,
    headers: {
      "Content-Type": "application/json",
      Authorization: token, // include if needed
    },
  });

  return client
    .post(url, data, { responseType: 'arraybuffer' })
    .then((res) => res.data)
    .catch((err) => {
      // API error handling
      if (err.response?.data?.error?.message?.valid === false) {
        const notyf = new Notyf();
        notyf.dismissAll();
        window.dispatchEvent(new Event("session-expired"));
        return; // stop promise chain (like Angular's EMPTY)
      }
      console.error("DashboardApi error:", err);
      return Promise.reject(err);
    });
};

export const ZendeskPostApi = async (url, data) => {
  const valid = await checkTokenExpiry();
  if (!valid) return;
  let token = sessionDataDec('token')
  const client = axios.create({
    baseURL: ZENDESK_BASE_URL,
    headers: {
      "Content-Type": "application/json",
      Authorization: token, // include if needed
    },
  });

  return client
    .post(url, data)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response?.data?.error?.message?.valid === false) {
        const notyf = new Notyf();
        notyf.dismissAll();
        window.dispatchEvent(new Event("session-expired"));
        return; // stop promise chain (like Angular's EMPTY)
      }
      console.error("LoginApi error:", err);
      return Promise.reject(err); // rethrow for caller
    });
};

export const PinCodeApi = async (data) => {

  const client = axios.create({
    baseURL: PINCODE_BASE_URL,
  });

  return client
    .post('', data) // only base URL, no extra path
    .then((res) => res.data)
    .catch((err) => {
      if (err.response?.data?.error?.message?.valid === false) {
        const notyf = new Notyf();
        notyf.dismissAll();
        window.dispatchEvent(new Event("session-expired"));
        return; // stop promise chain (like Angular's EMPTY)
      }
      console.error("PinCodeApi error:", err);
      return Promise.reject(err);
    });
};





